import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/bullet.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/brandResearch/industries.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/brandResearch/managers.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/brandResearch/stakeholders.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/consumerResearch/consumerinsights.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/productInsights/ourexprience.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/slm/icon/home.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/ModalOpener/index.tsx");
